(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-quiz"]) return;
  try {
    

      // Wait for the page to load before manipulating the DOM
        document.addEventListener("DOMContentLoaded", function () {
            // Check if the viewport width is greater than 768px (adjust this value as needed)
            if (window.innerWidth >= 768) {
                // Find the form and the target element
                const form = document.getElementById("FacetFiltersForm");
                const targetElement = document.getElementById("filter-stuff");

                // Check if both elements exist
                if (form && targetElement) {
                    // Show the form
                    form.style.display = "block";
                    
                    // Inject the form into the "filter-stuff" element
                    targetElement.appendChild(form);
                }
            }
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    

      // Wait for the page to load before manipulating the DOM
        document.addEventListener("DOMContentLoaded", function () {
            // Check if the viewport width is greater than 768px (adjust this value as needed)
            if (window.innerWidth >= 768) {
                // Find the form and the target element
                const form = document.getElementById("FacetFiltersForm");
                const targetElement = document.getElementById("filter-stuff");

                // Check if both elements exist
                if (form && targetElement) {
                    // Show the form
                    form.style.display = "block";
                    
                    // Inject the form into the "filter-stuff" element
                    targetElement.appendChild(form);
                }
            }
        });

  } catch(e) { console.error(e); }
})();
})();
